import type {CommitWithStatus} from '@github-ui/repos-types'
import React from 'react'

interface LatestCommitContextValue {
  latestCommit?: CommitWithStatus
  error: Error | null
  isLoading: boolean
}

const LatestCommitContext = React.createContext<LatestCommitContextValue>({
  latestCommit: undefined,
  error: null,
  isLoading: false,
})

export function LatestCommitProvider({
  children,
  latestCommit,
  error,
  isLoading,
}: React.PropsWithChildren<LatestCommitContextValue>) {
  const value = React.useMemo(() => ({latestCommit, error, isLoading}), [latestCommit, error, isLoading])
  return <LatestCommitContext value={value}>{children}</LatestCommitContext>
}

export function useLatestCommitContext() {
  return React.use(LatestCommitContext)
}
